var map = {
	"./components/add-to-cart/add-to-cart.js": "./theme/components/add-to-cart/add-to-cart.js",
	"./components/cart-item/cart-item.js": "./theme/components/cart-item/cart-item.js",
	"./components/dashboard-sidebar/dashboard-sidebar.js": "./theme/components/dashboard-sidebar/dashboard-sidebar.js",
	"./components/hero/hero.js": "./theme/components/hero/hero.js",
	"./components/modal/modal.js": "./theme/components/modal/modal.js",
	"./components/navbar/navbar.js": "./theme/components/navbar/navbar.js",
	"./components/order-card/order-card.js": "./theme/components/order-card/order-card.js",
	"./components/product-item/product-item.js": "./theme/components/product-item/product-item.js",
	"./components/quantity/quantity.js": "./theme/components/quantity/quantity.js",
	"./components/slider/slider.js": "./theme/components/slider/slider.js",
	"./components/toast/toasts.js": "./theme/components/toast/toasts.js",
	"./templates/login.js": "./theme/templates/login.js",
	"./templates/page-cart.js": "./theme/templates/page-cart.js",
	"./templates/register.js": "./theme/templates/register.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./theme sync recursive \\.\\/(?!(dist)).*\\/([^/]+\\/)*.+\\.js$";